import React from 'react';
import { Switch } from 'react-router-dom';
import loadable from '@loadable/component';

import { DescriptorRoute } from 'components/shared/DescriptorRoute';

const NotFoundPage = loadable(() => import('descriptors/pages/NotFoundPage'), {
  resolveComponent: (component) => component.NotFoundPage,
});

const LegalPage = loadable(() => import('descriptors/pages/LegalPage'), {
  resolveComponent: (component) => component.LegalPage,
});

const IndexPage = loadable(() => import('descriptors/pages/IndexPage'), {
  resolveComponent: (component) => component.IndexPage,
});

const ContactsPage = loadable(() => import('descriptors/pages/ContactsPage'), {
  resolveComponent: (component) => component.ContactsPage,
});

export const DescriptorRoutes = () => {
  return (
    <Switch>
      <DescriptorRoute path="/" component={IndexPage} exact />
      <DescriptorRoute path="/contacts" component={ContactsPage} />
      <DescriptorRoute
        path={[
          '/terms',
          '/(privacy|billing|refund|tracking)-policy',
          '/compliance-statement',
        ]}
        component={LegalPage}
      />

      <DescriptorRoute path="*" component={NotFoundPage} />
    </Switch>
  );
};
